import React, { useContext } from 'react';
import { Context } from '../@context/Context';
import { onChange, getPlanSubscribe } from '../@helper/common/common';
const onlyNum = RegExp('^[0-9]+$');

const onChangeCvv = (cvv, setCvv) => ({ target: { value } }) => {
    const changeCvv = value.length;
    const lastSymbol = value[changeCvv - 1];
    const addSymbol = cvv.length < changeCvv;

    if (value && !onlyNum.test(lastSymbol) && lastSymbol !== '*') {
        return;
    }

    if (addSymbol) {
        const newCvv = cvv + lastSymbol;
        return setCvv(newCvv);
    }

    const newCvv = cvv.slice(0, changeCvv);
    return setCvv(newCvv);
};

const hideCvv = (value) => {
    const hideValue = value.replace(/\d/g, '*');
    return hideValue;
};

const formatCardNumber = (oldValue, cardNumber) => {
    const cardLength = cardNumber.length;
    const oldValueLength = oldValue.length;

    if (oldValueLength > cardLength) {
        return cardNumber;
    }

    let part1 = '', part2 = '';

    if (cardLength === 4) {
        part1 = cardNumber.slice(0, 4);
        part2 = cardNumber.slice(4);
        cardNumber = part1 + ' ' + part2;
    }

    if (cardLength === 9) {
        part1 = cardNumber.slice(0, 9);
        part2 = cardNumber.slice(9);
        cardNumber = part1 + ' ' + part2;
    }

    if (cardLength === 14) {
        part1 = cardNumber.slice(0, 14);
        part2 = cardNumber.slice(14);
        cardNumber = part1 + ' ' + part2;
    }

    if (cardLength === 19) {
        part1 = cardNumber.slice(0, 19);
        part2 = cardNumber.slice(19);
        cardNumber = part1 + ' ' + part2;
    }

    return cardNumber;

};

const onChangeExpirationDate = (date, setExpirationDate) => ({ target: { value } }) => {
    let expirationDate = value;
    const lastNum = value.length;
    const lastSymbol = value[lastNum - 1];
    const addSymbol = date.length < lastNum;

    if (value && !onlyNum.test(lastSymbol) && lastSymbol !== '/') {
        return;
    }

    if (addSymbol) {
        if (lastNum === 2) {
            expirationDate = expirationDate + '/';
        }
        if (date.length === 2) {
            expirationDate = date + '/' + lastSymbol;
        }
        return setExpirationDate(expirationDate);
    }

    expirationDate = expirationDate.slice(0, lastNum);
    return setExpirationDate(expirationDate);
};

const onChangeCardNumber = (cardNumber, setCardNumber) => ({ target: { value } }) => {
    let testNum = value;

    if (value.includes(' ')) {
        testNum = testNum.split(' ');
        testNum = testNum.filter(i => i);
        testNum = testNum.join('');
    }

    if (value && !onlyNum.test(testNum)) {
        return;
    }
    const num = formatCardNumber(cardNumber, value);
    setCardNumber(num);
};

const Form = (props) => {
    const {
        state: {
            cardName,
            cardNumber,
            expirationDate,
            cvv,
            postalCode,
            error
        },
        actions: {
            setCardName,
            setCardNumber,
            setExpirationDate,
            setCvv,
            setPostalCode,
        }
    } = useContext(Context);

    let styleCardName = 'bank__form bank__form-main';
    let styleNumber = 'bank__form bank__form-main';
    let styleExpirationDate = 'bank__form bank__form-other';
    let styleCvv = 'bank__form bank__form-other';
    let stylePostalCode = 'bank__form bank__form-other';

    if (error.type === 'braintree') {

        styleCardName = error.body.cardName ? styleCardName + ' bank__form-err' : styleCardName;
        styleNumber = error.body.number ? styleNumber + ' bank__form-err' : styleNumber;
        styleExpirationDate = error.body.expirationDate ? styleExpirationDate + ' bank__form-err' : styleExpirationDate;
        styleExpirationDate = error.body.expirationMonth ? styleExpirationDate + ' bank__form-err' : styleExpirationDate;
        styleCvv = error.body.cvv ? styleCvv + ' bank__form-err' : styleCvv;
        stylePostalCode = error.body.postalCode ? styleCvv + ' bank__form-err' : stylePostalCode;
    }

    const { form } = getPlanSubscribe();


    return (
        <div className="container container_center">
            <div>
                <div className="bank__container">
                    <input className={styleCardName} name="ccname" autoComplete="cc-name" type="text" placeholder="Name on card" onChange={onChange(setCardName)} value={cardName} />
                    <input className={styleNumber} maxLength="23" name="cardnumber" autoComplete="cc-number" placeholder="0000 0000 0000 0000" type="tel" onChange={onChangeCardNumber(cardNumber, setCardNumber)} value={cardNumber} />
                </div>
                <div className="bank__form__inline">
                    <input className={styleExpirationDate} maxLength="5" name="cc-exp" autoComplete="cc-exp" placeholder="MM/YY" type="tel" onChange={onChangeExpirationDate(expirationDate, setExpirationDate)} value={expirationDate} />
                    <input className={styleCvv} maxLength="5" name="cvc" autoComplete="cc-csc" placeholder="CVC" type="tel" onChange={onChangeCvv(cvv, setCvv)} value={hideCvv(cvv)} />
                    <input className={stylePostalCode} minLength="2" maxLength="7" name="zip" placeholder="ZIP code" type="text" onChange={onChange(setPostalCode)} value={postalCode} />
                </div>
            </div>
        </div>
    );
};

export default Form;